import React from 'react';

// modals
import CompareModal from '../modals/CompareModal.js';
import DeleteProject from '../modals/DeleteProject.js';
import DeleteProjects from '../modals/DeleteProjects.js';
import DeleteFuse from '../modals/DeleteFuse.js';
import DeleteFusions from '../modals/DeleteFusions.js';
import DeletePitch from '../modals/DeletePitch.js';
import DeletePitches from '../modals/DeletePitches.js';
import IdeasModal from '../modals/IdeasModal.js';
import ShareModal from '../modals/ShareModal.js';

const ModalContainer = ({
  handleCloseModal,
  modalType,
  modalInfo,
  handleDeleteProject,
  handleDeleteProjects,
  handleDeleteFuse,
  handleDeleteFusions,
  handleDeletePitch,
  handleDeletePitches,
  fuseSavedData,
  fuseLoadingData,
  fetchFuse
}) => {
  return (
    <div className="fuselight-v5-modal-container">
      <div className="fuselight-v5-modal">
        <button className="close" onClick={handleCloseModal}></button>
        {modalType === 'compare' && (
          <CompareModal
            modalInfo={modalInfo}
            fetchFuse={fetchFuse}
            handleCloseModal={handleCloseModal}
          />
        )}
        {modalType === 'deleteProject' && (
          <DeleteProject
            modalInfo={modalInfo}
            handleCloseModal={handleCloseModal}
            handleDeleteProject={handleDeleteProject}
          />
        )}
        {modalType === 'deleteProjects' && (
          <DeleteProjects
            modalInfo={modalInfo}
            handleCloseModal={handleCloseModal}
            handleDeleteProjects={handleDeleteProjects}
          />
        )}
        {modalType === 'deleteFuse' && (
          <DeleteFuse
            modalInfo={modalInfo}
            handleCloseModal={handleCloseModal}
            handleDeleteFuse={handleDeleteFuse}
          />
        )}
        {modalType === 'deleteFusions' && (
          <DeleteFusions
            modalInfo={modalInfo}
            handleCloseModal={handleCloseModal}
            handleDeleteFusions={handleDeleteFusions}
          />
        )}
        {modalType === 'deletePitch' && (
          <DeletePitch
            modalInfo={modalInfo}
            handleCloseModal={handleCloseModal}
            handleDeletePitch={handleDeletePitch}
          />
        )}
        {modalType === 'deletePitches' && (
          <DeletePitches
            modalInfo={modalInfo}
            handleCloseModal={handleCloseModal}
            handleDeletePitches={handleDeletePitches}
          />
        )}
        {modalType === 'ideas' && (
          <IdeasModal
            modalInfo={modalInfo}
            fuseSavedData={fuseSavedData}
            fuseLoadingData={fuseLoadingData}
          />
        )}
        {modalType === 'share' && <ShareModal modalInfo={modalInfo} />}
      </div>
    </div>
  );
};

export default ModalContainer;
